import { Box, Divider, Grid, Paper, Typography } from "@mui/material";
import { CargoList } from "./components/cargo-list";
import { DriverSchedulingList } from "./components/drivers-scheduling/driver-scheduling-list";
import CargoContext from "../contexts/CargoContext";
import React from "react";
import { FleetMatchingDrivers } from "./fleets/fleets/fleet-matching-drivers";
import UserContext from "../contexts/UserContext";

export const Scheduling = () => {
  const { selectedCargo: rawSelectedCargo } = React.useContext(CargoContext);
  const { isScheduler } = React.useContext(UserContext);
  const selectedCargo = React.useMemo(() => rawSelectedCargo, [rawSelectedCargo]);

  return (
    <Grid
      container
      spacing={2}
      sx={{
        height: "calc(100vh - 96px)",
        overflow: "hidden",
      }}
    >
      <Grid
        item
        xs={12}
        lg={isScheduler ? 7 : 12}
        sx={{
          height: "100%",
          minHeight: 0,
        }}
      >
        <Paper
          variant="outlined"
          sx={{
            height: "100%",
            overflow: "auto",
            p: 1.5,
            borderRadius: 2,
            bgcolor: "background.paper",
          }}
        >
          <Typography variant="subtitle1" fontWeight={700} sx={{ mb: 1 }}>
            有效货物
          </Typography>
          <CargoList filter={{ status: 1 }} />
        </Paper>
      </Grid>
      {isScheduler && (
        <Grid
          item
          xs={12}
          lg={5}
          sx={{
            height: "100%",
            minHeight: 0,
          }}
        >
          <Paper
            variant="outlined"
            sx={{
              height: "100%",
              overflow: "auto",
              p: 1.5,
              borderRadius: 2,
              bgcolor: "background.paper",
            }}
          >
            <Typography variant="subtitle1" fontWeight={700} sx={{ mb: 1 }}>
              匹配司机（仅App）
            </Typography>
            <Box sx={{ minHeight: 0 }}>
              {selectedCargo && (
                <DriverSchedulingList selectedCargo={selectedCargo} />
              )}
            </Box>
            <Divider sx={{ my: 2 }} />
            <Typography variant="subtitle1" fontWeight={700} sx={{ mb: 1 }}>
              匹配车队司机（多渠道）
            </Typography>
            {selectedCargo && (
              <FleetMatchingDrivers selectedCargo={selectedCargo} />
            )}
          </Paper>
        </Grid>
      )}
    </Grid>
  );
};
